export default "__VITE_ASSET__cvm_b$UH__"